import moment from 'moment-timezone';
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { getStorageData } from "../../../framework/src/Utilities";
interface Patient {
  id: number;
  full_name: string;
  full_phone_number: string;
  country_code: number;
  phone_number: number;
  email: string;
  invite_response: string | null; // ✅ Allow null
  patient_response: string | null; // ✅ Allow null
  coordinator_response: string;
  profile_image: string;
  isPopoverOpen: boolean;
  selectedValue: string;
}

const PreviousTest: { [key: string]: string } = {
  "fr": "Précédent",
  "en": "Previous",
  "es": "Anterior",
  "de": "Vorherige",
}
const UpcomingTest: { [key: string]: string } = {
  "fr": "Prochain",
  "en": "Upcoming",
  "es": "Próximo",
  "de": "Demnächst",
}
const DurationHour: { [key: string]: string } = {
  "fr": "Durée Heure",
  "en": "Duration Hour",
  "es": "Duración Hora",
  "de": "Dauer Stunde",
}
const AddSchedule: { [key: string]: string } = {
  "fr": "Ajouter un horaire",
  "en": "Add Schedule",
  "es": "Agregar horario",
  "de": "Zeitplan hinzufügen",
}

const DailyText: { [key: string]: string } = {
  "fr": "Tous les jours",
  "en": "Daily",
  "es": "A diario",
  "de": "Täglich",
}

const WeeklyText: { [key: string]: string } = {
  "fr": "Hebdomadaire",
  "en": "Weekly",
  "es": "Semanalmente",
  "de": "Wöchentlich",
}
const MonthlyText: { [key: string]: string } = {
  "fr": "Mensuel",
  "en": "Monthly",
  "es": "Mensual",
  "de": "Monatlich",
}
const YearlyText: { [key: string]: string } = {
  "fr": "Annuel",
  "en": "Yearly",
  "es": "Anual",
  "de": "Jährlich",
}

const CustomText: { [key: string]: string } = {
  "fr": "Coutume",
  "en": "Custom",
  "es": "Costumbre",
  "de": "Brauch",
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  available_date: any;
  start_time: any;
  end_time: any;
  id: any;
  token: string;
  appointmentsList: any;
  isRefreshing: boolean;
  milestones: any;
  value: any;
  tabValue: any;
  prevPage: any;
  upcomingPage: any;
  currentPage: any;
  upcomingSchedules:any;
  previousSchedules:any
  open: boolean;
  selectedTimeZone: any;
  dataArray: any;
  checked: boolean;
  openTime: boolean;
  editorState: any;
  Reccurance: any;
  selectedDate: any;
  isDatePickerOpen: boolean;
  selectedTime: any;
  durations: any;
  minutes: any;
  selectedOption: any;
  openMilestone: boolean;
  openDuration: boolean;
  openMinute: boolean;
  setDuration: any;
  setMinute: any;
  endDate: any;
  title: any;
  address1: any;
  address2: any;
  address3: any;
  openMilestoneWithDrawer: boolean;
  selectedOption1: any;
  selectedDays: any;
  selectedStudy: any;
  openOnthe: boolean;
  onthe: any;
  onthevalue: any;
  openDay: boolean;
  dayOn: any;
  dayonvalue: any;
  dailyValue: any;
  WeeklyValue: any;
  MonthlyValue: any;
  on_day: any;
  yearlyDate: any;
  yearlyDayFormat: any;
  patientList: any;
  siteTimeZone: string;
  selectedRadioYear: any;
  selectedRadioMonth: any;
  weekdays: any;
  addPatientList: any;
  milestonesID: any;
  milestonesID1: any;
  selectedDayLong: any;
  showDate: any;
  tabs: { label: string, value: string | number }[];
  selectedTab: any;
  upcomming: any;
  page: number;
  previous: any;
  openPages: boolean;
  pageCount: any;
  setPages: any;
  itemsPerPage: number;
  openMenu: boolean;
  ismilestone:boolean;
  openMenuIndex: any;
  showDetails: boolean;
  SelectedAppointment: any;
  myCalenderFlag: boolean;
  ccDate: any;
  contentArray: any;
  add_Schedule_Title: any;
  editFlag: boolean;
  scheduleID: any;
  is_recurring:any;
  patientIdsArray: any;
  deleteFlag: boolean;
  editableTitle: boolean;
  editableDesc: boolean;
  errorTitle: any;
  errorDesc: any;
  erroradd1: any;
  erroradd2: any;
  erroradd3: any;
  customArray: any;
  customRepeatEveryArray: any;
  customRepeatEveryValue: any;
  customRepeatEveryFlag: boolean;
  customValue: any;
  customFlag: boolean;
  milstoneError: boolean;
  milstoneErrorText: any;
  milestoneNew: any;
  patientError: boolean;
  patientErrorText: any;
  startDateError: boolean;
  startDateErrorText: any;
  startTimeError: boolean;
  startTimeErrorText: any;
  recurringError: any;
  repeatEveryError: any;
  repeatEveryErrorText: any;
  recurringErrorText: any;
  durationError: boolean;
  durationErrorText: any;
  minuteError: boolean;
  minuteErrorText: any;
  addressError: boolean;
  addressErrorText: any;
  endDateErrorText: any;
  endDateError: boolean;
  openAttendence: boolean;
  attendencePatientList: Patient[];
  selectCoordinatorResp: any;
  coordinatorResp: boolean;
  attendenceID: any;
  scheduleOnCalender: any;
  calenderMonth: any;
  calenderYear: any;
  selectedEvent: any;
  allEvents: any;
  disableFlag: boolean;
  patientResponses: { [key: string]: string };
  coordinatorResponses: { [key: string]: string };
  showMoreEvents:boolean;
  eventsForDate:[];
  isDialogOpen:boolean
  milestonesIdNew: string
  displayedContent:any
  language: string;
  selectedValueCoordinator: string;
  selectedApiTime: any;
  // Customizable Area End
}

export interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class AppointmentmanagementController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  addAppointmentApiCallId: any;
  getAppointmentsListApiCallId: any;
  deleteAllAppointmentsApiCallId: any;
  getAllMilstoneCallId: any;
  getAllMilstoneCallIdNew: any;
  addScheduleApiCallId: any;
  getAllScheduleApiCallID: any;
  getScheduleDeleteApiCallID: any;
  editScheduleApiCallID: any;
  showScheduleAttendenceCallID: any;
  updateAttendenceCallID: any;
  getCalenderCallID: any;
  postSendNotificationCallID= '';
  dropdownRefs: (HTMLDivElement | null)[] = [];
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionResponseMessage),

      // Customizable Area End
    ];

    this.isStringNullOrBlank = this.isStringNullOrBlank.bind(this);
    let endTime = new Date();
    endTime.setMinutes(endTime.getMinutes() + 30);
    this.state = {
      // Customizable Area Start
      id: 0,
      start_time: new Date(),
      end_time: endTime,
      available_date: moment(new Date()).format("DD/MM/YY"),
      appointmentsList: [],
      token: "",
      isRefreshing: false,
      milestones: [],
      value: "",
      tabValue: 0,
      prevPage: 1,
      upcomingPage: 1,
      currentPage: 1,
      open: false,
      selectedTimeZone: '',
      dataArray: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
      checked: false,
      openTime: false,
      recurringError: "",
      repeatEveryError: "",
      repeatEveryErrorText: "",
      recurringErrorText: "",
      ismilestone:false,
      editorState: "",
      Reccurance: [DailyText[localStorage.getItem("language") || "en"], WeeklyText[localStorage.getItem("language") || "en"],
       MonthlyText[localStorage.getItem("language") || "en"], YearlyText[localStorage.getItem("language") || "en"], CustomText[localStorage.getItem("language") || "en"]],
      selectedDate: null,
      isDatePickerOpen: false,
      selectedTime: null,
      durations: ["0","1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17",
        "18", "19", "20", "21", "22", "23"],
      minutes: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17",
        "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35",
        "37", "38", "39", "40", "41", "42",
        "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57",
        "58", "59"],
      selectedOption: "",
      openMilestone: false,
      openDuration: false,
      openMinute: false,
      setDuration: "",
      setMinute: "",
      endDate: null,
      title: "",
      address1: "",
      address2: "",
      address3: "",
      openMilestoneWithDrawer: false,
      selectedOption1: "",
      selectedDays: "Mon",
      selectedStudy: "",
      openOnthe: false,
      onthe: ["First", "Second", "Third", "Fourth", "Fifth"],
      onthevalue: "",
      openDay: false,
      dayOn: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thusday", "Friday", "Saturday"],
      dayonvalue: "",
      dailyValue: "",
      WeeklyValue: "",
      MonthlyValue: "",
      on_day: "",
      yearlyDate: "",
      yearlyDayFormat: "",
      patientList: [],
      siteTimeZone: "UTC",
      selectedRadioYear: "",
      selectedRadioMonth: "",
      weekdays: [{ short: 'Sun', long: 'Sunday' }, { short: 'Mon', long: 'Monday' }, { short: 'Tue', long: 'Tuesday' },
      { short: 'Wed', long: 'Wednesday' }, { short: 'Thu', long: 'Thusday' },
      { short: 'Fri', long: 'Friday' }, { short: 'Sat', long: 'Saturday' }],
      addPatientList: [],
      milestonesID: "",
      milestonesID1: "",
      selectedDayLong: "Monday",
      showDate: "",
      tabs: [
        { label: "previous", value: PreviousTest[localStorage.getItem("language") || "en"] },
        { label: "upcoming", value: UpcomingTest[localStorage.getItem("language") || "en"] }
      ],
      selectedTab: "Previous",
      upcomming: [],
      page: 1,
      previous: [],
      previousSchedules: [],
      upcomingSchedules: [],
      openPages: false,
      pageCount: ["10", "15", "20", "25"],
      setPages: "",
      itemsPerPage: 10,
      openMenu: false,
      openMenuIndex: "",
      showDetails: false,
      SelectedAppointment: "",
      myCalenderFlag: false,
      ccDate: new Date(),
      contentArray: [],
      add_Schedule_Title: "Add Schedule",
      editFlag: false,
      scheduleID: "",
      is_recurring: false,
      patientIdsArray: [],
      deleteFlag: false,
      editableTitle: true,
      editableDesc: true,
      errorTitle: "",
      errorDesc: "",
      erroradd1: "",
      erroradd2: "",
      erroradd3: "",
      customArray: ["Day", "Week", "Month", "Year"],
      customRepeatEveryArray: ["1", "2", "3", "4", "5"],
      customRepeatEveryFlag: false,
      customRepeatEveryValue: "",
      customValue: "",
      customFlag: false,
      milstoneError: false,
      milstoneErrorText: "",
      milestoneNew: [],
      patientError: false,
      patientErrorText: "",
      startDateError: false,
      startDateErrorText: "",
      startTimeError: false,
      startTimeErrorText: "",
      durationError: false,
      durationErrorText: "",
      minuteError: false,
      minuteErrorText: "",
      addressError: false,
      addressErrorText: "",
      endDateErrorText: "",
      endDateError: false,
      openAttendence: false,
      attendencePatientList: [],
      selectCoordinatorResp: "Not Attended ",
      coordinatorResp: false,
      attendenceID: "",
      scheduleOnCalender: [],
      calenderMonth: "",
      calenderYear: "",
      selectedEvent: null,
      allEvents: [],
      disableFlag: false,
      patientResponses: {},
      coordinatorResponses: {},
      displayedContent:[],
      language: localStorage.getItem("language") || "en",
      showMoreEvents:false,
      eventsForDate:[],
      isDialogOpen:false,
      milestonesIdNew: "",
      selectedValueCoordinator: "",
      selectedApiTime: ""
      // Customizable Area End
    };

    // Customizable Area Start
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    super.componentDidMount();
    this.getToken();
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken();
      });
    }
    // Customizable Area Start
    this.getAllMileStones()
    this.getAllMileStonesNew()
    this.getcurrentDay()
    this.getCurrentDayMonthFormate()
    // Customizable Area End
  }

  getToken = () => {
    const msg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(msg);
  };

  receive = async (from: String, message: Message) => {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      let responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      if (apiRequestCallId != null) {
        if (apiRequestCallId === this.getAllMilstoneCallId && responseJson) {
          this.callResponceMilestone(responseJson)
        } else if (apiRequestCallId === this.addScheduleApiCallId && responseJson) {
          this.callResponceAddSchedule(responseJson)
        } else if (apiRequestCallId === this.getAllScheduleApiCallID && responseJson) {
          this.callResponceAllSchedule(responseJson);
        } else if (apiRequestCallId === this.getScheduleDeleteApiCallID && responseJson) {
          this.callResponceDelete(responseJson)
        } else {
          this.callOtherApis(apiRequestCallId, responseJson)
        }
      }

    }
    // Customizable Area End
  };

  // Customizable Area Start
  callSetResponce = (row: any) => {
    this.setState({
      coordinatorResp: !this.state.coordinatorResp,
      attendenceID: row.id
    })
  }
  callAttendence = () => {
    this.setState({
      openAttendence: !this.state.openAttendence,
    })
    this.callAppointmentAttendence();

  }

  handleLanguageSwitch = (language: string) => {
    localStorage.setItem("language", language)
    let tabs= [
      { label: "previous", value: PreviousTest[language] },
      { label: "upcoming", value: UpcomingTest[language] }
    ]
    this.setState({ language: language, tabs: tabs })
  }
 
  formatCoordinatorResponse = (value: any) => {
    if (value === "attended" || value === "Attended" || value === 0 || value === "0") {
      return "Attended";
    }
    if (
      value === "notAttended" ||
      value === "Not Attended" ||
      value === "Non Attended" ||
      value === 1 ||
      value === "1"
    ) {
      return "Non Attended";
    }
    return "";
  };

  callUpdateCoordinatorResponce = (value: any, row: any) => {
    let count = 0;
    if (value === "Attended") {
      count = 0
    } else if (value === "Not Attended" || value === "Non Attended") {
      count = 1
    }
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };
    const bodyis = {
      "schedule_patient": {
        "account_id": row,
        "coordinator_response": count
      }
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.updateshowScheduleApiEndPoint + this.state.SelectedAppointment.id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.addAppointmentAPiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(bodyis)
    );
    this.updateAttendenceCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  notificationApi = () => {
   this.setState({isDialogOpen: true})
    let token = localStorage.getItem("token")
    let study_id = localStorage.getItem("studyId")
    let studyIdNumber = Number(study_id) 
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };
    const bodyis = {
      id: studyIdNumber,
      start_date:  `${this.state.selectedEvent.ssdate} ${this.state.selectedEvent.sstime}`,
      end_date: `${this.state.selectedEvent.eedate} ${this.state.selectedEvent.eetime}`,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.postSendNotification
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.addAppointmentAPiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(bodyis)
    );
    this.postSendNotificationCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false, selectedEvent: null });
  };

  calculateYesEResponce = (array: any) => {
    let count = 0;
    if (array) {
      count = array.filter((response: { invite_response: string; }) => response.invite_response === "Accept").length;
    }
    return count
  }
  calculateNoResponce = (array: any) => {
    let count = 0;
    if (array) {
      count = array.filter((response: { invite_response: string; }) => response.invite_response === "Reject").length
    }
    return count
  }

  calculateMaybeResponce = (array: any) => {    
    let count = 0;
    if (array) {
      count = array.filter((response: { invite_response: string; }) => response.invite_response === "Maybe").length
    }
    return count
  }

  callAppointmentAttendence = () => {

    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };


    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.showScheduleAttendenceCallID = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.showScheduleApiEndPoint + this.state.SelectedAppointment.id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiMethod
    );


    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  callOtherApis = (apiRequestCallId: any, responseJson: any) => {
    if (apiRequestCallId === this.editScheduleApiCallID && responseJson) {
      this.callResponceEditApi(responseJson)
    } else if (apiRequestCallId === this.getAllMilstoneCallIdNew && responseJson) {
      this.callResponceofAllMilestone(responseJson)
    } else if (apiRequestCallId === this.showScheduleAttendenceCallID) {
      if (responseJson) {
        if (responseJson.data.attributes.patient_ids) {
          this.setState({ attendencePatientList: responseJson.data.attributes.patient_ids })
        }
      }
    } else if (apiRequestCallId === this.updateAttendenceCallID) {
      this.callAppointmentAttendence()
    } else if (apiRequestCallId === this.getCalenderCallID) {
      if (responseJson) {
        this.callResponceCalender(responseJson)
      }


    }
  }
  callFormateNewDate = (date1: any, time1: any) => {
    const timeText = (time1 || "00:00").toString().trim();
    const dateTimeMoment = moment(
      `${date1} ${timeText}`,
      [
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD HH:mm",
        "YYYY-MM-DD H:mm",
        "YYYY-MM-DD hh:mm:ss A",
        "YYYY-MM-DD hh:mm A",
      ],
      true
    );
    const parsed = dateTimeMoment.isValid()
      ? dateTimeMoment
      : moment(`${date1} ${timeText}`);

    return new Date(
      parsed.year(),
      parsed.month(),
      parsed.date(),
      parsed.hours(),
      parsed.minutes(),
      parsed.seconds() || 0
    );
  }

  parseDateOnly = (value: any): Date | null => {
    if (value == null || value === "" || value === "null") return null;

    if (moment.isMoment(value)) {
      if (!value.isValid()) return null;
      const utc = value.clone().utc();
      const utcMidnight = utc.hours() === 0 && utc.minutes() === 0 && utc.seconds() === 0;
      const source = utcMidnight ? utc : value;
      return new Date(source.year(), source.month(), source.date(), 12, 0, 0, 0);
    }

    if (value instanceof Date) {
      if (isNaN(value.getTime())) return null;
      const utcMidnight =
        value.getUTCHours() === 0 &&
        value.getUTCMinutes() === 0 &&
        value.getUTCSeconds() === 0 &&
        value.getUTCMilliseconds() === 0;
      if (utcMidnight) {
        return new Date(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate(), 12, 0, 0, 0);
      }
      return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12, 0, 0, 0);
    }

    const raw = String(value).trim().replace(/^"+|"+$/g, "");
    const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]), 12, 0, 0, 0);
    }

    const dayFirst = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (dayFirst) {
      return new Date(Number(dayFirst[3]), Number(dayFirst[2]) - 1, Number(dayFirst[1]), 12, 0, 0, 0);
    }

    const parsed = moment(raw);
    if (!parsed.isValid()) return null;
    return new Date(parsed.year(), parsed.month(), parsed.date(), 12, 0, 0, 0);
  };

  formatDateOnly = (value: any): string | null => {
    const date = this.parseDateOnly(value);
    if (!date) return null;
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
  };

  formatDisplayDate = (value: any): string => {
    const date = this.parseDateOnly(value);
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}/${month}/${date.getFullYear()}`;
  };

callResponceCalender = (responseJson: any) => {
  let events: any[] = [];
  const seenSeries = new Set<string>();
  const seenSlots = new Set<string>();

  const parseRepeatEvery = (val: string): number => {
    if (!val) return 1;
    const num = parseInt(val.replace(/\D/g, ""), 10);
    return isNaN(num) ? 1 : num;
  };

  const addEvent = (item: any, dateStr: string) => {
    const attr = item.attributes;
    const slotKey = `${dateStr}|${attr.start_time}|${attr.end_time}|${attr.title}|${attr.address || ""}`;
    if (seenSlots.has(slotKey)) return;

    const start = this.callFormateNewDate(dateStr, attr.start_time);
    if (isNaN(start.getTime())) return;
    seenSlots.add(slotKey);

    let end = this.callFormateNewDate(dateStr, attr.end_time || attr.start_time);
    const durationMs =
      ((Number(attr.duration_hour) || 0) * 60 + (Number(attr.minute) || 0)) * 60 * 1000;
    const endOnSameDay = this.formatDateOnly(end) === dateStr;
    if (isNaN(end.getTime()) || end <= start || !endOnSameDay) {
      end = new Date(start.getTime() + (durationMs > 0 ? durationMs : 60 * 60 * 1000));
    }

    events.push({
      id: item.id,
      title: attr.title,
      start,
      end,
      desc: attr.description,
      allDay: false,
      time_zone: attr.time_zone,
      ssdate: attr.start_date,
      sstime: attr.start_time,
      eedate: attr.end_date,
      eetime: attr.end_time,
      duration_hour: attr.duration_hour,
      minute: attr.minute,
      address: attr.address,
      patient_ids: attr.patient_ids,
      recurring_meeting: attr.recurring_meeting,
      repeat_every: attr.repeat_every,
      occurs_on: attr.occurs_on,
    });
  };

  const calendarDays = Array.isArray(responseJson) ? responseJson : [];

  calendarDays.forEach((dayObj: { date: string; schedule: { data: any[] } }) => {
    if (!dayObj.schedule?.data?.length) return;

    dayObj.schedule.data.forEach((item: any) => {
      const attr = item.attributes;
      const recurring = attr.recurring_meeting?.toLowerCase() || "none";
      const repeatGap = Math.max(parseRepeatEvery(attr.repeat_every), 1);
      const seriesKey = [
        recurring,
        attr.title,
        attr.start_date,
        attr.end_date,
        attr.start_time,
        attr.repeat_every,
        attr.occurs_on,
      ].join("|");

      const occurrenceDate = this.formatDateOnly(dayObj.date) || this.formatDateOnly(attr.start_date);
      if (occurrenceDate) addEvent(item, occurrenceDate);

      const repeatText = String(attr.repeat_every || "").toLowerCase();
      const period = String(attr.custom_period || "").toLowerCase();
      const weeklySeries = recurring === "weekly" || period === "week" || repeatText.includes("week");
      const dailySeries = !weeklySeries && (recurring === "daily" || period === "day" || repeatText.includes("day"));
      const monthlySeries = !weeklySeries && !dailySeries && (recurring === "monthly" || period === "month" || repeatText.includes("month"));

      if (weeklySeries || dailySeries || monthlySeries) {
        if (seenSeries.has(seriesKey)) return;
        seenSeries.add(seriesKey);

        const seriesStart = this.parseDateOnly(attr.start_date);
        const seriesEnd = this.parseDateOnly(attr.end_date) || seriesStart;
        if (!seriesStart || !seriesEnd) return;

        const current = new Date(seriesStart);
        let guard = 0;
        while (current <= seriesEnd && guard < 500) {
          const generated = this.formatDateOnly(current);
          if (generated) addEvent(item, generated);
          if (monthlySeries) {
            current.setMonth(current.getMonth() + repeatGap);
          } else {
            current.setDate(current.getDate() + (weeklySeries ? repeatGap * 7 : repeatGap));
          }
          guard += 1;
        }
      }
    });
  });

  console.log("✅ Final recurring events generated:", events);
  this.setState({ scheduleOnCalender: events, allEvents: responseJson });
};

  
  
  
callResponceofAllMilestone = (responseJson: any) => {
  console.log("NEW MILESTONE API:", responseJson);

  this.setState({
    milestoneNew: Array.isArray(responseJson)
      ? responseJson
      : responseJson?.milestones || []
  });
};
  handleNavigate = (date: any) => {
    const month = moment(date).format('MMMM');
    const year = moment(date).format('YYYY');
    this.setState({ calenderMonth: month, calenderYear: year }, () => { this.callGetCalenderSchedule() })

  };
  callResponceEditApi = (responseJson: any) => {
    if (responseJson.errors) {
      alert(JSON.stringify(responseJson.errors[0]))
    } else {
      alert(responseJson.message)
      this.handleDrawerCloseAdd();
      this.getAllAppointments(this.state.milestonesIdNew)
      this.getAllMileStones();
    }
  }
  callResponceDelete = (responseJson: any) => {
    alert(responseJson.message);
    this.getAllMileStones();
  }

  sortByDateTime = (list: any[]) => {
    return [...list].sort((a, b) => {
      const timeA = this.convertTo24Hour(a.attributes.start_time);
      const timeB = this.convertTo24Hour(b.attributes.start_time);
  
      const dateTimeA = new Date(
        `${a.attributes.start_date}T${timeA}:00`
      ).getTime();
  
      const dateTimeB = new Date(
        `${b.attributes.start_date}T${timeB}:00`
      ).getTime();
  
      return dateTimeA - dateTimeB; 
    });
  };
  convertTo24Hour = (time: string) => {
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);
  
    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;
  
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
  };
  
  callResponceAllSchedule = (responseJson: any) => {
    console.log(responseJson,"@@@@dfff")
    const upcoming =
    responseJson.upcoming_schedules?.data || [];

const previous =
responseJson.previous_schedules?.data || [];
const sortedUpcoming = this.sortByDateTime(upcoming);
const sortedPrevious = this.sortByDateTime(previous);
  
this.setState({
  upcomingSchedules: sortedUpcoming,
  previousSchedules: sortedPrevious,
  displayedContent: sortedUpcoming.slice(0, this.state.itemsPerPage),
});
    
  }
  handleEventClick = (event: any) => {
    this.setState({ selectedEvent: event })
  };

  callResponceAddSchedule = (responseJson: any) => {

    if (typeof responseJson.errors === "string") {
      this.setState({
        milstoneError: true,
        milstoneErrorText: responseJson.errors
      });
      return;
    }

    if (responseJson.errors) {
  
      if (responseJson.errors.hasOwnProperty("milestone_management")) {
        this.setState({
          milstoneError: true,
          milstoneErrorText: "Milestone must exist"
        });
      }
  
      if (responseJson.errors.hasOwnProperty("title")) {
        this.setState({ errorTitle: "Title can't be blank" });
      }
  
      if (responseJson.errors.hasOwnProperty("description")) {
        this.setState({ errorDesc: "Description must exist" });
      }
  
      if (responseJson.errors.hasOwnProperty("patient_ids")) {
        this.setState({
          patientErrorText: "Patient can't be blank",
          patientError: true
        });
      }
  
      if (responseJson.errors.hasOwnProperty("start_date")) {
        this.setState({
          startDateErrorText: "Start Date can't be blank",
          startDateError: true
        });
      }
  
      if (responseJson.errors.hasOwnProperty("start_time")) {
        this.setState({
          startTimeErrorText: "Start Time can't be blank",
          startTimeError: true
        });
      }
  
      if (responseJson.errors.hasOwnProperty("recurring_meeting")) {
        this.setState({
          recurringErrorText: "Recurring Meeting can't be blank",
          recurringError: true
        });
      }
  
      if (responseJson.errors.hasOwnProperty("repeat_every")) {
        this.setState({
          repeatEveryErrorText: "Repeat Every can't be blank",
          repeatEveryError: true
        });
      }
  
      this.callErrorResponce(responseJson);
  
    } else {
      this.callSuccesResponce();
    }
  };
  
  
  callErrorResponce = (responseJson: any) => {
    if (responseJson.errors.hasOwnProperty("duration_hour")) {
      this.setState({ durationErrorText: "Duration Time can't be blank", durationError: true })
    }
    if (responseJson.errors.hasOwnProperty("minute")) {
      this.setState({ minuteErrorText: "Minute can't be blank", minuteError: true })
    }
    if (responseJson.errors.hasOwnProperty("address")) {
      this.setState({ addressErrorText: "Address can't be blank", addressError: true })
    }
    if (responseJson.errors.hasOwnProperty("end_date")) {
      this.setState({
        endDateErrorText: responseJson.errors.end_date
        , endDateError: true
      })
    }
    if (responseJson.errors.hasOwnProperty("base")) {
      alert(responseJson.errors.base)
    }
  }
  callSuccesResponce = () => {
    alert("Schedule Added Successfully")
    this.handleDrawerCloseAdd();
    this.getAllMileStones();
  }
  callResponceMilestone = (responseJson: any) => {
    console.log("MILESTONE RESPONSE:", responseJson);
  
    const milestones = Array.isArray(responseJson)
      ? responseJson
      : responseJson?.milestones || [];
  
    this.setState({
      milestones: milestones,
      patientList: responseJson?.patients || [],
      siteTimeZone: responseJson?.time_zone || "UTC"
    });
  };
  formattedDateStart = (date: any) => {
    const date1 = this.parseDateOnly(date);
    if (!date1) return "";
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' };
    return date1.toLocaleDateString('en-US', options);
  }


  handleSelectTab = (value: string | number) => {
    this.setState({ selectedTab: value });
  }

  handleOptionChangeRadioYear = (event: any) => {
    this.setState({ selectedRadioYear: event.target.value });
  };
  handleOptionChangeRadioMonth = (event: any) => {
    this.setState({ selectedRadioMonth: event.target.value });
  };
  ShowAppointmentDetails = (content: any) => {

    this.setState({
      SelectedAppointment: content,
      showDetails: true
    })

  }
  getInitials(name: any) {
    if (name) {
      const words = name.split(' ');

      const initials = words.map((word: string) => word.charAt(0).toUpperCase());

      return initials.join('');
    }
  }
  closeAppointmeentDetails = () => {
    this.setState({ showDetails: !this.state.showDetails })
  }
  getCurrentDayMonthFormate() {
    const getNthDayOfMonth = (year: number, month: number, dayOfWeek: number, occurrence: number) => {
      const date = new Date(year, month, 1);
      let count1 = 0;
      while (date.getDay() !== dayOfWeek || ++count1 < occurrence) {
        date.setDate(date.getDate() + 1);
      }
      return date;
    };


    const currentDate = new Date();

    const dayOfWeek = currentDate.getDay();
    const dayOfMonth = currentDate.getDate();
    const positionInMonth = Math.floor((dayOfMonth - 1) / 7) + 1;

    const nthDayOfMonth = getNthDayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), dayOfWeek, positionInMonth);



    const getPositionInMonthString = (positionInMonth1: any) => {
      const positions = ['first', 'second', 'third', 'fourth', 'fifth'];

      const index = positionInMonth1 - 1;

      if (index >= 0 && index < positions.length) {
        return positions[index];
      }

    };

    const formattedDate = `${getPositionInMonthString(positionInMonth)} ${nthDayOfMonth.toLocaleString('en-US', { weekday: 'long' })} of ${nthDayOfMonth.toLocaleString('en-US', { month: 'long' })}`;
    this.setState({ yearlyDayFormat: formattedDate })
  }
  setStateFlag = (_flag: any, text: any) => {
    this.setState({
      openDuration: text === DurationHour[this.state.language]
        ? !this.state.openDuration
        : false,
  
      openMinute: text === "Minute"
        ? !this.state.openMinute
        : false,
  
      openOnthe: text === "Third"
        ? !this.state.openOnthe
        : false,
  
      openDay: text === "Tuesday"
        ? !this.state.openDay
        : false,
  
      openPages: text === "page"
        ? !this.state.openPages
        : false,
  
      customRepeatEveryFlag: text === "1"
        ? !this.state.customRepeatEveryFlag
        : false,
  
      customFlag: text === CustomText[this.state.language]
        ? !this.state.customFlag
        : false,
    });
  };

  getcurrentDay() {
    const currentDate = new Date();
    const month = currentDate.toLocaleString('en-US', { month: 'long' });
    const date = currentDate.getDate();
    const formattedDate = `${month}  ${date}`;
    this.setState({ yearlyDate: formattedDate })
  }
  handleChangeTimeZone = (event: any) => {
    this.setState({ selectedTimeZone: event.target.value })
  }
  // handleTimeChange = (time: any) => {    
  //   if (time) {
  //     const utcTime = moment.utc(time).format('hh:mm A');     
  //     this.setState({ selectedTime: time,selectedApiTime: utcTime, startTimeError: false });
  //   }
  // };
  handleTimeChange = (time: Date | null) => {
    if (!time) return;
  
    const siteTimeZone = this.state.siteTimeZone || "UTC";
  
    // browser time ko site timezone treat karo
    const siteTime = moment(time);
  
    // display ke liye (SITE TZ)
    const displayTime = siteTime.format("HH:mm");
  
    this.setState({
      selectedTime: time,
      selectedApiTime: displayTime,
      startTimeError: false
    });
  };
  
  
  handleChangeMonthlyValue = (event: any) => {
    const inputValue = event.target.value;

    if (/^\d*$/.test(inputValue)) {
      this.setState({ MonthlyValue: inputValue })
    }
  };
  handleChangeOnDayValue = (event: any) => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      this.setState({ on_day: inputValue })
    }
  };
  shiftDate = (startValue: any, days: number) => {
    const start = this.parseDateOnly(startValue);
    if (!start || !days) return null;
    const next = new Date(start.getTime());
    next.setDate(next.getDate() + days);
    return next;
  };

  handleChangeWeeklyValue = (event: any) => {
    const inputValue = event.target.value;

    if (/^\d*$/.test(inputValue)) {
      const weeks = Number(inputValue);
      const endDate = weeks > 0
        ? this.shiftDate(this.state.selectedDate, weeks * 7)
        : null;
      this.setState({
        WeeklyValue: inputValue,
        endDate: endDate || this.state.endDate,
        repeatEveryError: false,
        repeatEveryErrorText: ""
      })
    }
  };
  checkedBox = (event: any) => {
    const isChecked = event?.target?.checked;
  
    if (this.state.selectedDate) {
      this.setState({ checked: isChecked });
    } else {
      alert("For Recurring meeting Please select Start Date");
    }
  };
  

  handleChangeDailyValue = (event: any) => {
    const inputValue = event.target.value;

    if (/^\d*$/.test(inputValue)) {
      this.setState({
        dailyValue: inputValue,
        repeatEveryError: false,
       repeatEveryErrorText: ""
      })
    }

  };
  openCalender = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.toLocaleString('default', { month: 'long' });
    const currentYear = currentDate.getFullYear();
    this.setState({
      myCalenderFlag: !this.state.myCalenderFlag,
      calenderMonth: currentMonth, calenderYear: currentYear
    }, () => { this.callGetCalenderSchedule() });

  };
  closeAttendence = () => {
    this.setState({ openAttendence: !this.state.openAttendence });

  }
  callGetCalenderSchedule = async () => {

    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };

    const studyId = await getStorageData("studyId")

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getCalenderCallID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.calenderApiEndPoint + this.state.calenderMonth + '&year=' + this.state.calenderYear + `&study_id=${JSON.parse(studyId)}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiMethod
    );


    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  toggleDrawer = () => {
    this.setState({
      open: !this.state.open, editFlag: false, SelectedAppointment: null, 
      add_Schedule_Title: AddSchedule[this.state.language],
      selectedApiTime : ""
    });
  };
  handleDrawerCloseAdd = () => {
    this.setState({
      open: false,    openDuration: false,
      openMinute: false,
      openOnthe: false,
      openDay: false,
      openPages: false,
      customRepeatEveryFlag: false,
      customFlag: false,
      title: '', selectedOption: '', selectedDate: null, selectedTime: null,
      editorState: '', address1: '', address2: '', address3: '',
      value: "", setDuration: "", setMinute: "", endDate: null,
      addPatientList: [], checked: false, milestonesID: "", milstoneError: false,
      errorTitle: "", errorDesc: "", patientError: false, startDateError: false, startTimeError: false,
      durationError: false, minuteError: false, addressError: false
    })
  }

  handleOptionClick = (option: any, drawerFlag: boolean) => {
     this.setState({ismilestone:true})
    if (drawerFlag) {
      this.setState({ selectedOption1: option.name, openMilestoneWithDrawer: false, milestonesID1: option.id, milstoneError: false })
      this.getAllAppointments(option.id)
    } else {
      this.setState({
        selectedOption: option.name, openMilestone: false, milestonesID: option.id,
        milstoneError: false
      })
    }
  }

  handleOptionClickDay = (option: any) => {
    this.setState({ dayonvalue: option, openDay: false })
  }
  handleCustomRepeatEvery = (option: any) => {
    this.setState({
      customRepeatEveryValue: option,
      customRepeatEveryFlag: false,
    })
  }
  handleCustomValue = (option: any) => {
    this.setState({
      customValue: option,
      customFlag: false,
    })
  }
  handleOptionClickonthe = (option: any) => {
    this.setState({ onthevalue: option, openOnthe: false })
  }
  handleOptionClickDuration = (option: any) => {
    this.setState({ setDuration: option, openDuration: false, durationError: false })
  }
  callDateChangeFormat = (dateString: any) => {
    if (!dateString) return "-";
  
    const date = this.parseDateOnly(dateString);
  
    if (!date || isNaN(date.getTime())) {
      return "-";
    }
  
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };
  
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  };
  

  handleitemsPerPage = (option: any) => {
    this.setState({ setPages: option, itemsPerPage: option, openPages: false })
  }
  handleOptionClickMinute = (option: any) => {
    this.setState({ setMinute: option, openMinute: false, minuteError: false })
  }

  handleEditorChange = (text: string) => {
     const MAX_LENGTH = 1000;
  
    if (text.length >= MAX_LENGTH) {
      this.setState({
       editorState: text.slice(0, MAX_LENGTH),
        errorDesc: "Enter description with max 1000 characters",
      });
     } else {
      this.setState({
        editorState: text,
        errorDesc: "",
      });
     }
  };
  handleDateChange = (date: any) => {
    if (!date) {
      this.setState({
        selectedDate: null,
        showDate: "",
        startDateError: false,
      });
      return;
    }
  
    const formatted = this.formatDateOnly(date);
    if (!formatted) return;

    const dateChanged = formatted !== this.state.selectedDate;
    const weekly = String(this.state.value || "").toLowerCase() === "weekly";
    const weeks = Number(this.state.WeeklyValue);
    const endDate = dateChanged && weekly && weeks > 0
      ? this.shiftDate(formatted, weeks * 7)
      : this.state.endDate;
    this.setState(
      {
        selectedDate: formatted,
        showDate: this.formatDisplayDate(formatted),
        startDateError: false,
        endDate,
      },
      () => {
        if (dateChanged && this.state.value) {
          this.hadleSelectReccurance(this.state.value);
        }
      }
    );
  };
  
  
  endDatePickerOpen = false;
  pendingEndDate: any = null;
  endDateDirty = false;

  handleEndDateOpen = () => {
    this.endDatePickerOpen = true;
    this.pendingEndDate = null;
    this.endDateDirty = false;
  };

  handleEndDateClose = () => {
    this.endDatePickerOpen = false;
  };

  commitEndDate = (date: any) => {
    const normalized = this.parseDateOnly(date);
    if (!normalized) return;
    if (this.formatDateOnly(normalized) === this.formatDateOnly(this.state.endDate)) return;
    this.setState({ endDate: normalized, endDateError: false });
  };

  handleEndDateChange = (date: any) => {
    if (!this.endDatePickerOpen) return;
    const next = this.formatDateOnly(date);
    const start = this.formatDateOnly(this.state.selectedDate);
    if (!this.endDateDirty && next === start) return;
    this.endDateDirty = true;
    this.pendingEndDate = date;
    this.commitEndDate(date);
  };

  handleEndDateAccept = () => {
    if (!this.endDateDirty || !this.pendingEndDate) return;
    const date = this.pendingEndDate;
    this.pendingEndDate = null;
    this.endDateDirty = false;
    this.commitEndDate(date);
  };
  handleDayClick = (day: any) => {
    this.setState({
      selectedDays: day.short,
      selectedDayLong: day.long
    });
  };
  deleteItem = (item1: any) => {
    const updatedItems = this.state.addPatientList.filter((item: any) => item.id !== item1.id);
    this.setState({ addPatientList: updatedItems })

  }
  hadleSelectReccurance = (option: any) => {
    const keepEndDate = option === this.state.value;
    this.setState({
      value: option,
      endDate: keepEndDate ? this.state.endDate : null,
      recurringError: false,
      recurringErrorText: "",
    })

    const dateString = this.state.selectedDate;
    const date = this.parseDateOnly(dateString) || new Date(dateString);
    const dayNameAbbreviated = date.toLocaleString('en-US', { weekday: 'short' });
    const dayNameAbbreviated1 = date.toLocaleString('en-US', { weekday: 'long' });



    const dayOfMonth1 = date.getDate();


    const getNthDayOfMonth = (year: number, month: number, dayOfWeek: number, occurrence: number) => {
      const date = new Date(year, month, 1);
      let count = 0;
      while (date.getDay() !== dayOfWeek || ++count < occurrence) {
        date.setDate(date.getDate() + 1);
      }
      return date;
    };


    const dayOfWeek = date.getDay();
    const dayOfMonth = date.getDate();
    const positionInMonth = Math.floor((dayOfMonth - 1) / 7) + 1;

    const getPositionInMonthStringNew = (positionInMonth: any) => {
      const positions = ['first', 'second', 'third', 'fourth', 'fifth'];

      const index = positionInMonth - 1;

      if (index >= 0 && index < positions.length) {
        return positions[index];
      }

    };


    const nthDayOfMonth = getNthDayOfMonth(date.getFullYear(), date.getMonth(), dayOfWeek, positionInMonth);

    const formattedDate = `${getPositionInMonthStringNew(positionInMonth)} ${nthDayOfMonth.toLocaleString('en-US', { weekday: 'long' })} of ${nthDayOfMonth.toLocaleString('en-US', { month: 'long' })}`;



    const month2 = date.toLocaleString('en-US', { month: 'long' });
    const date2 = date.getDate();
    const formattedDate1 = `${month2}  ${date2}`;

    if (option === "Weekly") {
      this.setState({ selectedDays: dayNameAbbreviated, selectedDayLong: dayNameAbbreviated1 })
    }

    if (option === "Monthly") {

      this.setState({
        on_day: dayOfMonth1,
        onthevalue: getPositionInMonthStringNew(positionInMonth),
        dayonvalue: nthDayOfMonth.toLocaleString('en-US', { weekday: 'long' })
      })
    }
    if (option === "Yearly") {


      this.setState({
        yearlyDate: formattedDate1,
        yearlyDayFormat: formattedDate,

      })
    }
    if (option === "Custom") {
      this.setState({
        selectedDays: dayNameAbbreviated, selectedDayLong: dayNameAbbreviated1,
        yearlyDate: formattedDate1,
        yearlyDayFormat: formattedDate,
        on_day: dayOfMonth1,
        onthevalue: getPositionInMonthStringNew(positionInMonth),
        dayonvalue: nthDayOfMonth.toLocaleString('en-US', { weekday: 'long' })
      })
    }
  }
  handleSelectNew = (option: any) => {
    this.setState({ selectedTimeZone: option })
   
  }
  handleFlag=(flag:boolean)=>{
if(flag){
  this.setState({openMilestone:false})
}
  }
  handleSelect = (option: any, newArray: any) => {
    this.setState({
      addPatientList: newArray, patientError: false
    })

  };
  isStringNullOrBlank(str: string) {
    return str === null || str.length === 0;
  }
  getData = (data: any) => {
    this.setState({ addPatientList: data })
  }
  getUpdatedData = (data: any) => {
    this.setState({ displayedContent: data })
  }
  setIsOpen = (flag: any) => {
    this.setState({ openMilestone: flag, })
  }

  setIsOpen1 = (flag: any) => {
    this.setState({ openMilestoneWithDrawer: flag })
  }
  changeTitle = (event: any) => {

    if (event.target.value.length <= 25) { // Validate input length
      this.setState({
        title: event.target.value,
        errorTitle: ""
      })
    } else {
      this.setState({ errorTitle: "Enter Title with Max 25 characters" })
    }
  }
  changeAddress1 = (event: any) => {
    if (event.target.value.length <= 25) {
      this.setState({
        address1: event.target.value,
        erroradd1: "",
        addressError: false
      })
    } else {
      this.setState({ erroradd1: "Enter Address with Max 35 characters" })
    }
  }
  changeAddress2 = (event: any) => {
    if (event.target.value.length <= 25) {
      this.setState({
        address2: event.target.value,
        erroradd2: "",
        addressError: false
      })
    } else {
      this.setState({ erroradd2: "Enter Address with Max 35 characters" })
    }
  }
  changeAddress3 = (event: any) => {
    if (event.target.value.length <= 25) {
      this.setState({
        address3: event.target.value,
        erroradd3: "",
        addressError: false
      })
    } else {
      this.setState({ erroradd3: "Enter Address with Max 35 characters" })
    }
  }
  ShowMenu = (event: any, index: any) => {

    event.stopPropagation();
    this.setState({
      openMenu: !this.state.openMenu,
      showDetails: false,
      openMenuIndex: index
    })
  }
  addAppointment(): boolean {
    if (
      this.isStringNullOrBlank(this.state.available_date) ||
      this.isStringNullOrBlank(this.state.start_time) ||
      this.isStringNullOrBlank(this.state.end_time)
    ) {
    }

    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      token: this.state.token,
    };

    const attrs = {
      start_time: moment(this.state.start_time).format("HH:mm A"),
      end_time: moment(this.state.end_time).format("HH:mm A"),
      availability_date: moment(this.state.available_date, "DD/MM/YY").format(
        "YY/MM/DD"
      ),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.addAppointmentApiCallId = requestMessage.messageId;

    const httpBody = {
      ...attrs,
    };
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.appointmentAPiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.addAppointmentAPiMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  getAppointmentList = (token: any) => {
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      token: token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    const attrs = {
      service_provider_id: "1",
      availability_date: this.state.available_date,
    };

    this.getAppointmentsListApiCallId = requestMessage.messageId;
    let urlParams = new URLSearchParams(attrs).toString();

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.appointmentAPiEndPoint}?${urlParams}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  navigateToAppointments = () => {
    this.props.navigation.navigate("Appointments");
  };
  // Customizable Area Start
  getAllMileStonesNew = () => {
    let parseData;
    let studyNameStore = localStorage.getItem("studyName")
    if (studyNameStore != null) {
      parseData = JSON.parse(studyNameStore)
    }


    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };


    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getAllMilstoneCallIdNew = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getAllMileStoneEndPointNew + parseData.id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiMethod
    );


    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  getAllMileStones = () => {
    let parseData;
    let studyNameStore = localStorage.getItem("studyName")
    if (studyNameStore != null) {
      parseData = JSON.parse(studyNameStore)
    }


    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };


    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getAllMilstoneCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getAllMileStoneEndPoint + parseData.id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiMethod
    );


    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  callLog = () => {
    if (this.state.editFlag) {
      if (this.state.addPatientList && this.state.addPatientList.length > 0) {
        let arr = [];
        arr = this.state.addPatientList.map((item: { id: any; }) => item.id);
        this.setState({ patientIdsArray: arr }, () => { this.editScheduleApi() })

      } else {
        this.editScheduleApi()
      }
    } else {
      if (this.state.addPatientList && this.state.addPatientList.length > 0) {
        let arr = [];
        arr = this.state.addPatientList.map((item: { id: any; }) => item.id);
        this.setState({ patientIdsArray: arr }, () => { this.SubmitAddSchedule() })

      } else {
        this.SubmitAddSchedule()
      }

    }
  }
  SelectMethod = () => {

    if (this.state.editFlag) {
      this.setState({ add_Schedule_Title: "Edit Schedule", })
    } else {
      this.setState({ add_Schedule_Title: AddSchedule[this.state.language], })
    }
    this.callLog();
  }
  callStateVariable = () => {
    let repeatValue = "";
    const type = this.state.value?.toLowerCase();
    console.log("VALUE:", this.state.value);
console.log("TYPE:", this.state.value?.toLowerCase());
console.log("DAILY:", this.state.dailyValue);
console.log("FINAL:", repeatValue);

    if (type === 'daily') {
      repeatValue = `${this.state.dailyValue || 1} days`;
    } else if (type === 'weekly') {
      repeatValue = `${this.state.WeeklyValue || 1} weeks`;
    } else if (type === 'monthly') {
      repeatValue = `${this.state.MonthlyValue || 1} months`;
    } else if (type === 'custom') {
      const period = String(this.state.customValue || "").toLowerCase();
      const count = this.state.customRepeatEveryValue || 1;
      const unit =
        period === "day" ? "days" :
        period === "week" ? "weeks" :
        period === "month" ? "months" :
        period === "year" ? "years" : "";
      if (unit) repeatValue = `${count} ${unit}`;
    }
    // const timeObj = new Date(this.state.selectedTime);
    // const utcTime = new Date(timeObj.getTime() - timeObj.getTimezoneOffset() * 60000);

    // Extract YYYY-MM-DD (local)
    const datePart = new Date(this.state.selectedDate).toISOString().split("T")[0];
   // const timeString = new Date(utcTime).toISOString().split("T")[1];
  //  const combinedDateTime = `${datePart}T${timeString}`;
    const timeObj = this.state.selectedTime;
    const formattedStartTime = moment(timeObj).format("HH:mm");
    const body = {
      "milestone_management_id": this.state.milestonesID,
      "title": this.state.title,
      "is_recurring": this.state.checked,
      "description": this.state.editorState,
      "start_date": this.formatDateOnly(this.state.selectedDate) || this.state.selectedDate,
      "start_time": formattedStartTime,
      "address": this.state.address1 + " " + this.state.address2 + " " + this.state.address3,
      "recurring_meeting": (this.state.value).toLowerCase(),
      "occurs_on": this.state.selectedDays,
      "end_date": this.formatDateOnly(this.state.endDate),
      "on_day": this.state.on_day,
      "on_the": this.state.onthevalue,
      "month": this.state.yearlyDate,
      "day_month": this.state.yearlyDayFormat,
      "day_on_the": this.state.dayonvalue,
      "duration_hour": this.state.setDuration,
      "minute": this.state.setMinute,
      "patient_ids": this.state.patientIdsArray,
      "repeat_every": repeatValue,
      "time_zone": this.state.siteTimeZone,
      "custom_period":this.state.customValue
    }
    return body
  }
  editScheduleApi = () => {
    let token = localStorage.getItem("token")
    let arr: any[] = [];
    if (this.state.addPatientList && this.state.addPatientList.length > 0) {
      arr = this.state.addPatientList.map((item: { id: any }) => item.id);
    }
    
    this.setState({ patientIdsArray: arr });
    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };
    const bodyis = {
      ...this.callStateVariable(),
      patient_ids: arr
    };


    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.editScheduleApiEndPoint + this.state.scheduleID
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiPutMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(bodyis)
    );
    this.editScheduleApiCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  SubmitAddSchedule = () => {
    let token = localStorage.getItem("token")
    if (this.state.addPatientList && this.state.addPatientList.length > 0) {
      let arr = [];
      arr = this.state.addPatientList.map((item: { id: any; }) => item.id);
      this.setState({ patientIdsArray: arr })

    }

    const header = {
      "Content-Type": configJSON.appointmentApiContentType,
      "token": token
    };
    const bodyis = this.callStateVariable()

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.addScheduleEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.addAppointmentAPiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(bodyis)
    );
    this.addScheduleApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getAllAppointments = (milestone_id: any) => {
    this.setState({ milestonesIdNew: milestone_id })
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getAllScheduleApiCallID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getAllAppointment + milestone_id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getAppointmentListAPiMethod
    );


    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  showDailogDelete = (contentid: any) => {
    this.setState({ deleteFlag: true, scheduleID: contentid })
  }
  handleDeleteItemClick = () => {
    this.setState({ deleteFlag: false })
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getScheduleDeleteApiCallID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getScheduleDeleteApiEndPoint + this.state.scheduleID
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.deleteAllAppointmentsAPiMethod
    );


    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  capitalize = (str: string) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  isSameWeekday = (stored: any, day: any) => {
    const value = String(stored || "").toLowerCase();
    return value === String(day.short || "").toLowerCase() || value === String(day.long || "").toLowerCase();
  };

  recurrenceLabelFromAttributes = (attributes: any) => {
    const lang = this.state.language || "en";
    const repeat = String(attributes?.repeat_every || "").toLowerCase();
    let key = String(attributes?.recurring_meeting || "").toLowerCase();
    if (!key || key === "none" || key === "null") {
      if (repeat.includes("week")) key = "weekly";
      else if (repeat.includes("day")) key = "daily";
      else if (repeat.includes("month")) key = "monthly";
      else if (repeat.includes("year")) key = "yearly";
    }
    const labels: { [key: string]: string } = {
      daily: DailyText[lang],
      weekly: WeeklyText[lang],
      monthly: MonthlyText[lang],
      yearly: YearlyText[lang],
      custom: CustomText[lang],
    };
    return labels[key] || "";
  };

  appointmentIsRecurring = (attributes: any) => {
    const flag = attributes?.is_recurring;
    if (flag === true || flag === 1 || flag === "1" || String(flag).toLowerCase() === "true") {
      return true;
    }
    return this.recurrenceLabelFromAttributes(attributes) !== "";
  };

  handleEditItemClick = (content: any) => {
    const timeString = content.attributes.view_start_time || content.attributes.start_time; // Example time string
    const [time, period] = timeString.split(' '); // Split the time string into time and period (AM/PM)
    let [hours, minutes] = time.split(':').map(Number); // Split the time into hours and minutes
    if (hours === 12) {
      hours = period === 'AM' ? 0 : 12;
    } else if (period === 'PM') {
      hours += 12;
    }
    const selectedTime = new Date();
    selectedTime.setHours(hours);
    selectedTime.setMinutes(minutes);

    const attributes = content.attributes || {};
    const isRecurring = this.appointmentIsRecurring(attributes);
    const recurrenceLabel = this.recurrenceLabelFromAttributes(attributes);
    const repeatNumber = String(attributes.repeat_every || "").replace(/\D/g, "") || "1";
    const lang = this.state.language || "en";
    const recurrenceKey = recurrenceLabel.toLowerCase();

    const milestoneId = Number(
      content.attributes.milestone_management_id
    );
    const foundItem = this.state.milestoneNew.find(
      (item: any) => Number(item.id) === milestoneId
    );
    console.log("EDIT milestone ID:", milestoneId);
console.log("AVAILABLE milestones:", this.state.milestoneNew);
console.log("FOUND milestone:", foundItem);
    
    if (foundItem) {
      this.setState({
        selectedOption: foundItem.name,
        milestonesID: foundItem.id
      });
    }

    const occursOn = content.attributes.occurs_on;
    const matchedDay = (this.state.weekdays || []).find(
      (day: any) =>
        String(day.short).toLowerCase() === String(occursOn || "").toLowerCase() ||
        String(day.long).toLowerCase() === String(occursOn || "").toLowerCase()
    );

    this.setState({
      open: true,
      editFlag: true,
      SelectedAppointment: content,   
      scheduleID: content.id,
      checked: isRecurring,
      is_recurring: isRecurring,
      value: recurrenceLabel,
      dailyValue: recurrenceKey === String(DailyText[lang] || "").toLowerCase() ? repeatNumber : "",
      WeeklyValue: recurrenceKey === String(WeeklyText[lang] || "").toLowerCase() ? repeatNumber : "",
      MonthlyValue: recurrenceKey === String(MonthlyText[lang] || "").toLowerCase() ? repeatNumber : "",
      add_Schedule_Title: "Edit Schedule",
      selectedTimeZone: content.attributes.time_zone,
      title: content.attributes.title,
      editorState: content.attributes.description,
      addPatientList: content.attributes.patient_ids,
      selectedDate: this.formatDateOnly(content.attributes.start_date) || content.attributes.start_date,
      showDate: this.formatDisplayDate(content.attributes.start_date),
      selectedTime: selectedTime,
      address1: content.attributes.address,
      setDuration: content.attributes.duration_hour,
      setMinute: content.attributes.minute,
      endDate: this.parseDateOnly(content.attributes.end_date),
      customValue: content.attributes.custom_period || this.state.customValue,
      customRepeatEveryValue: repeatNumber,
      selectedDays: matchedDay ? matchedDay.short : content.attributes.occurs_on,
      selectedDayLong: matchedDay ? matchedDay.long : this.state.selectedDayLong,
      on_day: content.attributes.on_day,
      onthevalue: content.attributes.on_the,
      yearlyDate: content.attributes.month,
      yearlyDayFormat: content.attributes.day_month,
      dayonvalue: content.attributes.day_on_the,

    })
  }
  

  toggleDropdown = (index: number) => {
    this.setState(
      (prevState) => ({
        attendencePatientList: prevState.attendencePatientList.map((item, i) => ({
          ...item,
          isPopoverOpen: i === index ? !item.isPopoverOpen : false, // Toggle only clicked dropdown
        })),
      }),
      () => {
        document.removeEventListener("click", this.handleClickOutside);
        if (this.state.attendencePatientList[index]?.isPopoverOpen) {
          setTimeout(() => {
            document.addEventListener("click", this.handleClickOutside);
          }, 0);
        }
      }
    );
  };

  handleChangeAttendedData = (event: React.ChangeEvent<HTMLInputElement>, index: number ,rowid : number) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      selectedValueCoordinator: value,
      attendencePatientList: prevState.attendencePatientList.map((item, i) =>
        i === index ? { ...item, selectedValue: value, isPopoverOpen: false } : item
      ),
    }), () => {
      this.callUpdateCoordinatorResponce(value, rowid);
    });

  };

  closeAllDropdowns = () => {
    this.setState({
      openDuration: false,
      openMinute: false,
      openOnthe: false,
      openDay: false,
      openPages: false,
      customRepeatEveryFlag: false,
      customFlag: false,
    });
  };

  handleClickOutside = (event: MouseEvent) => {
    if (
      this.dropdownRefs.some(
        (ref) => ref && ref.contains(event.target as Node)
      )
    ) {
      return; // Ignore clicks inside the dropdown
    }
  
    this.setState((prevState) => ({
      attendencePatientList: prevState.attendencePatientList.map((item) => ({
        ...item,
        isPopoverOpen: false,
      })),
    }));
    document.removeEventListener("click", this.handleClickOutside);
  };

  callFormattedDateShow = (date1: string) => {
    return moment.utc(date1).format("HH:mm");
  };
  // Customizable Area End
}
